import React, { useEffect, useState, useRef } from 'react';
import useOutsideClick from '../../../hook/useOutsideClick';
import cx from 'classnames';

export const TitleElement = function FromElement({ element, isActive, handlerTitleSettings }) {
  const [style, setStyle] = useState({
    fontSize: element.options.fontSize,
    textAlign: element.options.alignment,
  });
  const elemRef = useRef();
  const [fieldIsActive, setFieldIsActive] = useState(false);
  useOutsideClick(elemRef, () => setFieldIsActive(false));

  useEffect(() => {
    setStyle(() => {
      return {
        fontSize: `${element.options.fontSize}px`,
        textAlign: element.options.alignment,
      };
    });
  }, [element]);

  return (
    <div
      onClick={() => setFieldIsActive(true)}
      ref={elemRef}
      className={cx('from-builder-title form-builder-element-preview', { 'form-builder-element-preview-active': fieldIsActive })}
    >
      <h1 style={style}>
        <i className="icon-file-text"></i>
        {element.options.value}
      </h1>

      <div className={`form-builder-element-preview-action`}>
        <button onClick={handlerTitleSettings} className="btn btn-settings btn-icon">
          <i className="icon-settings"></i>
        </button>
      </div>
    </div>
  );
};
